import {
    Create,
    DateInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
    AutocompleteInput,
} from '@/components/admin';

export const ServiceTicketCreate = () => (
    <Create title="New Service Ticket" className="p-6">
        <SimpleForm className="max-w-4xl mx-auto">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <TextInput source="title" label="Ticket Title" isRequired />
                <SelectInput
                    source="category"
                    label="Category"
                    choices={[
                        { id: 'maintenance',  name: '🔧 Maintenance' },
                        { id: 'installation', name: '🏗️ Installation' },
                        { id: 'repair',       name: '🛠️ Repair' },
                        { id: 'inspection',   name: '🔍 Inspection' },
                    ]}
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <SelectInput
                    source="priority"
                    label="Priority"
                    defaultValue="medium"
                    isRequired
                    choices={[
                        { id: 'low',      name: '⚪ Low' },
                        { id: 'medium',   name: '🔵 Medium' },
                        { id: 'high',     name: '🟡 High' },
                        { id: 'critical', name: '🔴 Critical' },
                    ]}
                />
                <SelectInput
                    source="status"
                    label="Status"
                    defaultValue="open"
                    isRequired
                    choices={[
                        { id: 'open',        name: 'Open' },
                        { id: 'in_progress', name: 'In Progress' },
                        { id: 'resolved',    name: 'Resolved' },
                        { id: 'closed',      name: 'Closed' },
                    ]}
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <ReferenceInput source="company_id" reference="companies">
                    <SelectInput label="Customer / Company" optionText="name" />
                </ReferenceInput>
                <ReferenceInput source="project_id" reference="projects">
                    <SelectInput label="Linked Project" optionText="name" />
                </ReferenceInput>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mb-4">
                <ReferenceInput source="assigned_to" reference="sales">
                    <AutocompleteInput 
                        label="Assigned To" 
                        optionText={(record: any) => record ? `${record.first_name} ${record.last_name}` : ''}
                        className="w-full"
                    />
                </ReferenceInput>
                <DateInput source="due_date" label="Due Date" />
            </div>

            <div className="w-full">
                <TextInput source="description" label="Description" multiline rows={4} />
            </div>
        </SimpleForm>
    </Create>
);
